import React from "react";
import { FederatedApp } from "@dtsl/react-utils";
import { federatedAppData } from "../common";

const CommonNavImpl = () => {
    const env = ENVIRONMENT;
    const navigationProps={
        env,
        isAppMFE: false,
        isNavExpanded: false,
        highlightedRoutes: {}
    }
    const navigationData=federatedAppData[env]["commonNavigation"];

    return (
        <FederatedApp
            appData={navigationData}
            appProps={navigationProps}
            fallback={<></>}
        />
    )
}

export default CommonNavImpl;